import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  success: false,
  deletedScorecardOwnership: null,
};

export const deleteScorecardSlice = createSlice({
  name: "deleteScorecard",
  initialState,
  reducers: {
    deleteScorecardStart: (state) => ({
      ...state,
      loading: true,
    }),
    deleteScorecardSuccess: (state, action) => ({
      ...state,
      loading: false,
      success: true,
      deletedScorecardOwnership: action.payload
    }),
    deleteScorecardFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    resetDeleteScorecard: () => ({
      ...initialState
    })
  },
});

const { actions, reducer } = deleteScorecardSlice;

export const { 
  deleteScorecardStart,
  deleteScorecardSuccess,
  deleteScorecardFailure,
  resetDeleteScorecard,
} = actions;

export const deleteScorecard = (scorecardId, deletedScorecardOwnership) => (dispatch) => {
  dispatch(deleteScorecardStart());
  apiService.delete(`${Constants.API.SCORE_CARD}/${scorecardId}`).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(deleteScorecardSuccess(deletedScorecardOwnership));
    } else {
      dispatch(deleteScorecardFailure());
    }
  }).catch(() => {
    dispatch(deleteScorecardFailure());
  })
}

export default reducer;
